import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, NgZone, HostListener } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';
import {
  FormControl,
  FormGroup
} from "@angular/forms";
import { DataStoreService } from '../services';
import { BnNgIdleService } from 'bn-ng-idle';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-elavon-hpp',
  templateUrl: './elavon-hpp.component.html',
  styleUrls: ['./elavon-hpp.component.css']
})
export class ElavonHPPComponent implements OnInit, AfterViewInit {

  @ViewChild('hppForm')
  hppFormElement: ElementRef;

  @ViewChild('hppFrame')
  hppFrameElement: ElementRef;

  @Input() currency;
  @Input() amount;
  @Input() email;
  @Input() orderId;

  result = {};
  paymentStatus = "";
  statusCode = "";
  statusMessage = "";
  realOrderId = "";

  @HostListener('window:message', ['$event'])
  onMessage(event: Event) {
    try {
      console.log('EVENT DATA: ', event);
      const messageData = JSON.parse(event['data']);
      // console.log(messageData);
      if (messageData['iframe']) {
        // this.resizeiFrame(messageData['iframe'].height, messageData['iframe'].width);
      }
      else {
        // Payment status
        for (const [key, value] of Object.entries(messageData)) {
          this.result[`${key}`] = atob(`${value}`);
        }
        this.apiService.logPaymentResponse(
          this.dataStore.selectedLocation,
          this.dataStore.selectedService,
          this.orderId,
          this.result
        );

        this.dataStore.paymentResponse = this.result;

        if (this.result['RESULT'] === "00") {
          this.paymentStatus = "Successful"
          this.router.navigate(['/confirmation']);

        } else {
          this.paymentStatus = "Failed"
        }

        this.statusCode = this.result['RESULT'];
        this.statusMessage = this.result['MESSAGE']
      }
    }
    catch(err) {
      this.apiService.logPaymentExtra(
        this.dataStore.selectedLocation,
        this.dataStore.selectedService,
        this.orderId,
        {type: 'elavon_response_error', err: err}
      );
    }
  }
  form: FormGroup = new FormGroup({
    'TIMESTAMP': new FormControl(""),
    'SHA1HASH': new FormControl(""),
    'MERCHANT_ID': new FormControl(""),
    'ACCOUNT': new FormControl(""),
    'AMOUNT': new FormControl(""),
    'CURRENCY': new FormControl(""),
    'ORDER_ID': new FormControl(""),
    'HPP_VERSION': new FormControl(""),
    'AUTO_SETTLE_FLAG': new FormControl(""),
    'MERCHANT_RESPONSE_URL': new FormControl(""),
    'HPP_BILLING_CITY': new FormControl(""),
    'HPP_BILLING_COUNTRY': new FormControl(""),
    'HPP_BILLING_STREET1': new FormControl(""),
    'HPP_BILLING_STREET2': new FormControl(""),
    'HPP_BILLING_STREET3': new FormControl(""),
    'HPP_BILLING_POSTALCODE': new FormControl(""),
    'HPP_CUSTOMER_EMAIL': new FormControl(""),
    'HPP_ADDRESS_MATCH_INDICATOR': new FormControl(""),
    'HPP_CUSTOMER_PHONENUMBER_MOBILE': new FormControl(""),
    'HPP_POST_DIMENSIONS': new FormControl(""),
    'HPP_POST_RESPONSE': new FormControl("")

  });

  constructor(
    private dataStore: DataStoreService,
    private apiService: ApiService,
    private bnIdle: BnNgIdleService,
    private ngZone: NgZone,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.paymentSetup();
  }

  paymentSetup() {
    // stop the timeout at this point
    this.bnIdle.stopTimer();

    if (!this.currency) {
      this.currency = 'EUR';
    }
    if (!this.orderId) {
      this.orderId = Date.now();
    }
    if (!this.dataStore.paymentRetryCount) {
      this.dataStore.paymentRetryCount = 1;
    }
    else {
      this.dataStore.paymentRetryCount++;
    }
    if (this.dataStore.paymentRetryCount == 1) {
      this.realOrderId = `${this.orderId}`;
    }
    else {
      this.realOrderId = `${this.orderId}-${this.dataStore.paymentRetryCount}`;
    }
    this.dataStore.realOrderId = this.realOrderId;

    this.form.get('HPP_BILLING_CITY').setValue('Halifax');
    this.form.get('HPP_BILLING_COUNTRY').setValue('826');
    this.form.get('HPP_BILLING_STREET1').setValue('Flat 123');
    this.form.get('HPP_BILLING_STREET2').setValue('House 456');
    this.form.get('HPP_BILLING_STREET3').setValue('Unit 4');
    this.form.get('HPP_BILLING_POSTALCODE').setValue('W5 9HR');
    this.form.get('HPP_CUSTOMER_EMAIL').setValue(this.email);
    this.form.get('HPP_ADDRESS_MATCH_INDICATOR').setValue(false);
    this.form.get('HPP_CUSTOMER_PHONENUMBER_MOBILE').setValue('353|789456123');
    this.form.get('HPP_VERSION').setValue(2);
    this.form.get('AUTO_SETTLE_FLAG').setValue(1);
    this.form.get('CURRENCY').setValue(this.currency);
    this.form.get('MERCHANT_RESPONSE_URL').setValue('https://urgentpassportappointment.dfa.ie/payment');
    this.form.get('HPP_POST_RESPONSE').setValue('https://urgentpassportappointment.dfa.ie/payment');
    this.form.get('HPP_POST_DIMENSIONS').setValue('https://urgentpassportappointment.dfa.ie/payment');
    this.form.get('MERCHANT_ID').setValue('irishpassportcards');
    this.form.get('ACCOUNT').setValue('passportonline');

    const ts = this.getTimeStamp();

    const hash = this.genHash(this.amount, ts, `${this.realOrderId}`);

    this.form.get('TIMESTAMP').setValue(ts);

    this.form.get('ORDER_ID').setValue(`${this.realOrderId}`);

    this.form.get('AMOUNT').setValue(this.amount);

    this.form.get('SHA1HASH').setValue(hash);

    this.apiService.logPaymentRequest(
      this.dataStore.selectedLocation,
      this.dataStore.selectedService,
      this.orderId,
      this.amount
    );

    setTimeout(() => {
      const parent = this.hppFrameElement.nativeElement.parentNode;
      this.hppFrameElement.nativeElement.parentNode.removeChild(this.hppFrameElement.nativeElement);
      this.dataStore.parentID = 37000;
      delete this.dataStore.clientDetails;
      delete this.dataStore.applicationDetails;
      delete this.dataStore.applicantArray;
      delete this.dataStore.applicantArrayCopy;
      delete this.dataStore.bookingQuestion;
      delete this.dataStore.dynamicForm;
      this.dataStore.basketItems.length = 0;

      this.ngZone.run(() => this.router.navigate(['/sessionExpired']));

    }, (60000 * 60));
  }

  ngAfterViewInit(): void {
    this.hppFormElement.nativeElement.submit();
  }

  paymentPost(event) {
    console.log(event);
  }

  genHash(amount, ts, orderId) {
    const initialHashString = `${ts}.irishpassportcards.${orderId}.${amount}.EUR`;
    const initialHash = CryptoJS.SHA1(initialHashString);

    const secretHashString = `${initialHash}.PtYFmMQ1Hh`;
    const secretHash = CryptoJS.SHA1(secretHashString);

    return `${secretHash}`;
  }

  getTimeStamp() {
    const ts = moment().format('YYYYMMDDHHmmss');
    return ts;
  }

  resizeiFrame(height, width) {
    this.hppFrameElement.nativeElement.style.height = height;
    this.hppFrameElement.nativeElement.style.width = width;
  }


  restartPayment() {
    this.paymentStatus = "";
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/payment']);
    });
  }

}
